import { classNames } from "@utils/classNames";
import React, { FC } from "react";
import { AssignedTag, NewTag, TagType } from "types/tags";

interface Props {
  tags?: (AssignedTag & NewTag)[];
  tagCN?: string;
}

export const EmploymentTypesBlock: FC<Props> = ({ tags = [], tagCN }) => {
  const employmentTypeTags = tags?.filter(
    (t) => t.type === TagType.EMPLOYMENT_TYPE
  );

  return (
    <>
      {employmentTypeTags.map(({ id, label }) => (
        <a
          key={id}
          href={`/search?tags=${id}`}
          className="hover:underline"
          rel="nofollow"
        >
          <span className={classNames(tagCN)}>{label || id}</span>
        </a>
      ))}
    </>
  );
};
